module.exports = __webpack_public_path__ + "img/q1_2021.a6ba9b59.jpg";